import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FMPText from "../components/pureForm/FMPText";
import Formula from "../components/ui/Formula";

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign : 'left',
		boxSizing: 'border-box',
		padding : 25,
		paddingBottom : 30,
		marginTop : 20,
		[theme.breakpoints.up('md')]: {
			padding : '10px 40px 40px 40px',
		}
	},
	formulaContainer : {
		//border : '1px solid #eee',
		fontSize : 14,
		backgroundColor : '#f7f7f7',
		marginTop : 10,
		marginBottom : 5,
		border : '1px solid #ddd'
	},
	formulaTitle : {
		fontSize : 13,
		textTransform: 'uppercase',
		//fontWeight : 800,
		color : '#555',
		paddingTop : 7,
		backgroundColor : '#f0f0f0',
		padding: 7,
	},
	formulaRow : {
		display : 'flex',
		flexDirection : 'row',
		paddingTop : 10,
		paddingBottom : 10,
	},
	formulaRowBreak : {
		display : 'flex',
		flexDirection : 'row',
		paddingBottom : 2,
		paddingTop : 20,
	},
	formulaSubTitle : {
		paddingTop : 20,
		display : 'flex',
		flexDirection : 'row',
		textAlign : 'left',
		borderBottom: '.5px solid #ddd',
		textTransform: 'uppercase',
		paddingBottom : 2,
		marginBottom: 10,
		color: '#555',
	},
	formulaTotal : {
		borderTop : '2px solid #ccc',
		paddingTop : '5px',
		marginTop : '5px',
		display : 'flex',
		flexDirection : 'row',
		fontWeight : '800',
		paddingBottom : '15px',
		fontSize : 16,
	},
	formulaSubtotal : {
		display : 'flex',
		flexDirection : 'row',
		fontWeight : '800',
		paddingBottom : 20,
	},
	formulaSubtotalLine : {
		height : 2,
		display : 'flex',
		marginLeft : '10%',
		marginRight : '10%',
		borderTop : '1px solid #ddd',
		paddingTop : '3px',
		marginTop : '3px',
		flexDirection : 'row',
		fontWeight : '800',
	},
	formulaLabel : {
		color : '#333',
		flexBasis : '70%',
		textAlign : 'right',
		paddingRight : '8px',
	},
	formulaValue : {
		color : '#666',
		flexBasis : '30%',
		textAlign : 'left',
		fontWeight : 800,
		fontSize : 16,
	},
});


class Blends extends Component {

	constructor (props) {
		super(props);
		this.state = {
			gallonsAvailableFromAlltech : 8150,
		};
	}

	//- Complicated because it handles values as events or paths as arrays
	onChange = (value, path) => {
		const arrayPath = (_.isString(path))
			? _.toPath(path)
			: path;

		const val = (_.isObject(value) && value.target)
			? value.target.value
			: value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};


		if (_.isArray(base) || _.isObject(base)) {

			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), val);
				newState[basePath] = base;
			} else {
				newState[basePath] = val;
			}
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	getInputProps = (path) => {
		return {
			path,
			value  : this.getValue(path),
			error : this.getError(path),
			onChange : this.onChange,
			md : 12,
		};
	};

	render() {
		const { classes } = this.props;

		const  gallonsAvailableFromAlltech = parseInt(this.state.gallonsAvailableFromAlltech, 10);

		//let unleaded = '-';
		//let totalE85 = '-';

		const formulaRows = [];
		const formulaNotes = [];
		if (!_.isNumber(gallonsAvailableFromAlltech)) {
			formulaNotes.push('Gallons must be a number. Come on now....');
		} else {

			const percentUnleaded = (gallonsAvailableFromAlltech / .98) - gallonsAvailableFromAlltech;
			const toBeSoldAsDenaturedToAllTech = percentUnleaded / .9;
			const totalE5denaturedToBeInvoicedToAllTech = gallonsAvailableFromAlltech + toBeSoldAsDenaturedToAllTech;
			const totalE85 = _.round(totalE5denaturedToBeInvoicedToAllTech / .8335);
			const unleadedNeeded = totalE85 - gallonsAvailableFromAlltech;


			formulaRows.push({ label : 'Percent Unleaded', value : percentUnleaded });
			formulaRows.push({ label : 'To be sold as denatured to AllTech', value : toBeSoldAsDenaturedToAllTech});
			formulaRows.push({ label : 'Total E85 denatured to be invoiced to AllTech', value : totalE5denaturedToBeInvoicedToAllTech});

			formulaRows.push({ label : 'Unleaded to be picked up by carrier', value : unleadedNeeded, isTotal : true});
			formulaRows.push({ label : 'Total E85 to deliver', value : totalE85, isTotal : true});
		}


		return (<Grid container spacing={3}>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<Grid container spacing={3}>
						<Grid item md={6}>
							<FMPText
								label={`Gallons of E100 available from Alltech`}
								{...this.getInputProps('gallonsAvailableFromAlltech')}
							/>

							<Formula
								formulaTitle={'All Tech Blend'}
								formulaRows={formulaRows}
							/>

						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Grid>);
	}
}

Blends.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
])(Blends);